import { Button } from 'antd';
import { t } from 'ttag';
import './accessDenied.scss';
import ExclamationIconV2 from './assets/images/exclamation-icon-v2.png';

/**
 * Renders the access-denied screen shown when the current network is not authorized for a facility's data. Displays an exclamation icon, the reconnect-or-contact-your-administrator explanation, and a Try Again button that reloads the app at the root path.
 *
 * @returns The access-denied page markup.
 */
const AccessDenied = () => (
  <div className="access-denied">
    <img src={ExclamationIconV2} alt="exclamation icon" />
    <div className="access-denied__content">
      <h3>{t`Access denied`}</h3>
      <p>
        {t`Your current network is not authorized to access this facility's data. Please reconnect to your organization's approved network or contact your facility administrator for support.`}
      </p>
      <Button
        onClick={() => {
          window.location.href = '/';
        }}
        block
        type="primary"
        size="large"
      >
        {t`Try Again`}
      </Button>
    </div>
  </div>
);

export default AccessDenied;
